// EventNames.ts
export const Events = {
  FORM_RULES: {
    UPDATE: 'FORM_RULES_UPDATE',
  },
} as const;